import store from '@/store'
const alphabetical = new Intl.Collator(store.state.locale || undefined).compare
export default alphabetical
